/*
 * Copyright 2012-2016 the original author or authors
 * @license MIT, see LICENSE.txt for details
 *
 * @author Scott Andrews
 */
'use strict';
/**
 * Create a new JSON converter with custom reviver/replacer.
 *
 * The extended converter must be published to a MIME registry in order
 * to be used. The existing converter will not be modified.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON
 *
 * @param {function} [reviver=undefined] custom JSON.parse reviver
 * @param {function|Array} [replacer=undefined] custom JSON.stringify replacer
 */

function createConverter(reviver, replacer) {
  return {
    read: function (str) {
      return JSON.parse(str, reviver);
    },
    write: function (obj) {
      return JSON.stringify(obj, replacer);
    },
    extend: createConverter
  };
}

module.exports = createConverter();